import "./StatusMessage.css";

/**
 * Inline feedback for a form or action, in place of `alert()`.
 *
 * `message` is `{ type: "error" | "success", text }` or null.
 */
export default function StatusMessage({ message, onDismiss }) {
  if (!message) return null;

  return (
    <div
      className={`status-message status-message-${message.type}`}
      role={message.type === "error" ? "alert" : "status"}
    >
      <span>{message.text}</span>
      {onDismiss && (
        <button
          type="button"
          className="status-message-dismiss"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          &times;
        </button>
      )}
    </div>
  );
}

export const errorStatus = (text) => ({ type: "error", text });
export const successStatus = (text) => ({ type: "success", text });
